module.exports = __webpack_public_path__ + "img/5y.c739823e.png";